import { withVersion } from 'api/utils/withVersion';
export var getPasswordPath = function getPasswordPath() {
    return withVersion.v1('/account/password');
};
export var getResetPasswordPath = function getResetPasswordPath() {
    return withVersion.v1('/account/password/reset');
};
export var getJumpCloudSsoPath = function getJumpCloudSsoPath(tenant) {
    return withVersion.v1("/oidc/".concat(tenant, "/login"));
};
export var getJumpCloudSsoCallbackPath = function getJumpCloudSsoCallbackPath(tenant) {
    return withVersion.v1("/oidc/".concat(tenant, "/callback"));
};
